import React from 'react';
import { LoaderIcon } from './icons';
import { Button, ButtonSize, ButtonVariant } from '../../../Button';

export interface ModalFooterProps {
  cancelButtonText?: string;
  confirmButtonText?: string;
  onCancel: () => void;
  formId?: string;
  isLoading?: boolean;
  isCancelButtonDisabled?: boolean;
  isCancelButtonHidden?: boolean;
  isConfirmButtonDisabled?: boolean;
  isConfirmButtonSecondary?: boolean;
  isConfirmButtonDanger?: boolean;
  buttonsSize?: ButtonSize;
  onConfirm?: () => void;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  cancelButtonText,
  confirmButtonText,
  formId,
  isLoading = false,
  isCancelButtonDisabled = false,
  isCancelButtonHidden = false,
  isConfirmButtonDisabled = false,
  isConfirmButtonSecondary = false,
  isConfirmButtonDanger = false,
  buttonsSize = ButtonSize.S,
  onCancel,
  onConfirm,
}) => {
  const getConfirmButtonVariant = () => {
    if (isConfirmButtonDanger) {
      return ButtonVariant.Danger;
    }

    if (isConfirmButtonSecondary) {
      return ButtonVariant.Secondary;
    }

    return null;
  };

  const confirmButtonVariant = getConfirmButtonVariant();

  const attrs = {
    container: {
      className: 'modal-footer',
    },
    cancelButton: {
      size: buttonsSize,
      variant: ButtonVariant.Secondary,
      onClick: onCancel,
      disabled: isLoading || isCancelButtonDisabled,
    },
    confirmButton: {
      size: buttonsSize,
      type: formId ? ('submit' as const) : ('button' as const),
      className: `modal-footer__button${
        isLoading ? ' modal-footer__button--loading' : ''
      }${isCancelButtonHidden ? ' modal-footer__button--ml-auto' : ''}`,
      onClick: onConfirm,
      disabled: isLoading || isConfirmButtonDisabled,
      ...(confirmButtonVariant ? { variant: confirmButtonVariant } : {}),
      ...(formId ? { form: formId } : {}),
    },
    buttonLoader: {
      className: 'modal-footer__button-loader',
    },
  };

  return (
    <div {...attrs.container}>
      {!isCancelButtonHidden ? (
        <Button {...attrs.cancelButton}>
          <span>{cancelButtonText}</span>
        </Button>
      ) : null}
      <Button {...attrs.confirmButton}>
        <span>{confirmButtonText}</span>
        {isLoading ? <LoaderIcon {...attrs.buttonLoader} /> : null}
      </Button>
    </div>
  );
};

export default ModalFooter;
